import { render, staticRenderFns } from "./nobind.vue?vue&type=template&id=5c0908b9&scoped=true&"
import script from "./nobind.vue?vue&type=script&lang=js&"
export * from "./nobind.vue?vue&type=script&lang=js&"
import style0 from "./nobind.vue?vue&type=style&index=0&id=5c0908b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0908b9",
  null
  
)

export default component.exports